import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="main-footer" data-testid="footer">
      <div className="container-wide">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Services */}
          <div>
            <h4 className="footer-heading">Services</h4>
            <Link to="/services" className="footer-link">Business Insurance</Link>
            <Link to="/services" className="footer-link">Personal Insurance / Private Client</Link>
            <Link to="/services" className="footer-link">Benefits Solutions</Link>
          </div>

          {/* About Us */}
          <div>
            <h4 className="footer-heading">About Us</h4>
            <Link to="/about" className="footer-link">Our Mission</Link>
            <Link to="/about" className="footer-link">Community</Link>
            <Link to="/resources" className="footer-link">Resources</Link>
            <Link to="/claims" className="footer-link">Claims</Link>
          </div>

          {/* Contact */}
          <div>
            <h4 className="footer-heading">Contact</h4>
            <p className="footer-text">
              Archon Insurance Agency<br />
              Massachusetts
            </p>
            <p className="footer-text mt-3">
              <strong>Email:</strong><br />
              <a href="mailto:monte@archoninsurance.com" className="footer-link">monte@archoninsurance.com</a>
            </p>
          </div>

          {/* Latest */}
          <div>
            <h4 className="footer-heading">Latest News</h4>
            <p className="footer-text text-sm">
              Stay informed with the latest insurance news and updates from Archon Insurance.
            </p>
            <Link to="/resources" className="footer-link mt-2 inline-block">View Resources →</Link>
          </div>
        </div>

        <div className="footer-bottom text-center">
          <p>&copy; {new Date().getFullYear()} Archon Insurance Agency. All rights reserved. Licensed in Massachusetts.</p>
          <p className="mt-2">
            Insurance products offered through licensed agents. Compliant with Massachusetts General Laws.
          </p>
        </div>
      </div>
    </footer>
  );
};
